<template>
  <div class="section section_no-padding-bottom section_white">
    <div class="max-width">
      <div class="faq">
        <div class="section__head section__head_middle">
          <h2 class="section__title">Frequently Asked <br>Questions</h2>
          <div class="section__text">
            All the information and assistance you need for a seamless experience with your online shop.
          </div>
          <div class="section__buttons">
            <router-link to="/contacts" class="button">
              Get in Touch
              <IconArrow/>
            </router-link>
          </div>
        </div>

        <div class="faq__list">
          <div
              v-for="(item, index) in faqs"
              :key="index"
              class="faq__item"
          >
            <div class="faq__label">
              {{ item.question }}
              <span><i></i><i></i></span>
            </div>
            <div class="faq__text">{{ item.answer }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import IconArrow from "@/components/icons/IconArrow.vue";
import {onMounted} from 'vue';

const faqs = [
  {
    question: 'Can I customize themes to match my brand?',
    answer: 'Yes, you can definitely customize our themes to match your brand. They include flexible options for colors, fonts, layouts, sections, and more—no coding required.'
  },
  {
    question: 'Are theme updates included with the purchase and for how long?',
    answer: 'Yes, theme updates are included for free with your purchase. You\'ll receive ongoing updates to keep your theme compatible with Shopify’s latest features.'
  },
  {
    question: 'What kind of support is available for themes?',
    answer: 'We offer dedicated support for all of our themes. If you run into setup questions or technical issues, our team is here to help you get back on track.'
  },
  {
    question: 'Are there any additional costs associated with themes?',
    answer: 'No, our themes are a one-time purchase with no recurring fees. The theme includes everything you need to launch and run your store.'
  }
];

onMounted(() => {
  const faqList = document.querySelector('.faq');
  if (faqList) {
    const faqLabels = document.querySelectorAll('.faq__label');

    function closeAllItems() {
      document.querySelectorAll('.faq__item').forEach(item => {
        item.classList.remove('faq__item_active');
        item.querySelector('.faq__text').style.maxHeight = 0;
        item.querySelector('.faq__text').style.paddingTop = 0;
      });
    }

    function openItem(faqItem) {
      faqItem.classList.add('faq__item_active');
      const faqText = faqItem.querySelector('.faq__text');
      faqText.style.maxHeight = faqText.scrollHeight + 18 + 'px';
      faqText.style.paddingTop = 10 + 'px';
    }

    faqLabels.forEach(label => {
      label.addEventListener('click', () => {
        const faqItem = label.parentElement;
        const isActive = faqItem.classList.contains('faq__item_active');
        closeAllItems();
        if (!isActive) {
          openItem(faqItem);
        }
      });
    });
    const firstItem = document.querySelector('.faq__item');
    if (firstItem) {
      openItem(firstItem);
    }
  }
});
</script>

<style lang="scss">
.faq {
  &__list {
    max-width: 784px;
    margin: 0 auto;
    gap: 1.25rem;
    display: flex;
    flex-direction: column;
  }

  &__item {
    border-radius: 16px;
    border: 1px solid var(--color-border);
    padding: 1.5rem 1.5rem 1.75rem;
    transition: var(--transition);
    cursor: pointer;
  }

  &__label {
    user-select: none;
    display: flex;
    gap: 1.5rem;
    font-weight: 600;
    font-size: 1.125rem;
    align-items: center;
    justify-content: space-between;

    span {
      display: block;
      flex: none;
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: var(--color-accent);
      transition: var(--transition);
      position: relative;

      i {
        width: 1px;
        height: 14px;
        background: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: var(--transition);
        transform-origin: top;

        &:last-child {
          transform: rotate(90deg) translate(-50%, -50%);
        }
      }
    }
  }

  &__item_active &__label span {
    background: #EAEAEA;

    i {
      background: var(--color-main);

      &:first-child {
        transform: rotate(90deg) translate(-50%, -50%);
      }
    }
  }

  &__text {
    max-width: 530px;
    max-height: 0;
    overflow: hidden;
    color: var(--color-gray);
    transition: var(--transition);
    padding-top: 0;
  }

  &__item_active &__text {
    max-height: 1000px;
    padding-top: 10px;
  }
}
</style>
